
export type NavigationItem = Readonly<{
  id: string;
  label: string;
  route: string;
  unavailable?: boolean;
  /** Role UX hint cho navigation; backend vẫn là thẩm quyền enforcement action + scope. */
  requiredRole?: "NCC_ADMIN" | "AUDITOR";
  requiredAction?: string;
}>;

export type NavigationGroup = Readonly<{
  id: string;
  label: string;
  items: readonly NavigationItem[];
}>;

export const navigationGroups: readonly NavigationGroup[] = Object.freeze([
  { id: "martyrs", label: "Liệt sĩ", items: [
    { id: "martyr-list", label: "Hồ sơ liệt sĩ", route: "/martyrs" },
  ] },
  { id: "grave-cemetery", label: "Mộ & nghĩa trang liệt sĩ", items: [
    { id: "cemeteries", label: "Nghĩa trang liệt sĩ", route: "/cemeteries" },
    { id: "memorial-entries", label: "Sổ tang điện tử", route: "/cemeteries/memorial-entries" },
  ] },
  { id: "administration", label: "Hệ thống", items: [
    { id: "administration-area", label: "Cơ quan & địa bàn", route: "/administration", requiredRole: "NCC_ADMIN" },
    { id: "user-accounts", label: "Tài khoản người dùng", route: "/administration/accounts", requiredRole: "NCC_ADMIN" },
    { id: "role-assignments", label: "Vai trò & phạm vi", route: "/administration/roles-scopes", requiredRole: "NCC_ADMIN" },
  ] },
]);

export const navigationItems = navigationGroups.flatMap((group) => group.items);

export function findNavigationItem(pathname: string): NavigationItem | undefined {
  return navigationItems
    .filter((item) => {
      if (item.route === "/") return pathname === "/";
      if (item.route.includes(":")) {
        const pattern = "^" + item.route.replace(/:[^/]+/g, "[^/]+") + "(/.*)?$";
        return new RegExp(pattern).test(pathname);
      }
      return pathname === item.route || pathname.startsWith(`${item.route}/`);
    })
    .sort((left, right) => right.route.length - left.route.length)[0];
}

export type NavigationGrant = Readonly<{
  actionCodes?: readonly string[];
}>;

export type NavigationActor = Readonly<{
  grants?: readonly NavigationGrant[];
}>;

export function isNavigationItemVisible(
  item: NavigationItem,
  roleCodes: readonly string[],
  actor?: NavigationActor | null
): boolean {
  if (item.requiredAction) {
    if (!actor?.grants) return false;
    const required = item.requiredAction;
    return actor.grants.some(
      (grant: NavigationGrant) => Boolean(grant.actionCodes?.includes(required)),
    );
  }
  return !item.requiredRole || roleCodes.includes(item.requiredRole);
}
